import {Injectable} from '@angular/core';
import {IApi} from '@entities/api';
import {
  ILoginConfirmationPayload,
  ILoginPayload,
  ITokenResponse,
  IUser,
  TLoginInfo,
} from '@entities/authentication/authentication.interfaces';
import {ApiService} from '@shared/services';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationApi extends ApiService {
  private authUrl = `${this.apiUrl}/users/auth`;

  public login(payload: ILoginPayload): Observable<IApi<TLoginInfo>> {
    return this.post<IApi<TLoginInfo>>(this.authUrl, payload);
  }

  public confirmLogin(
    payload: ILoginConfirmationPayload
  ): Observable<IApi<ITokenResponse>> {
    return this.post<IApi<ITokenResponse>>(this.authUrl, payload);
  }

  public getUser(): Observable<IApi<IUser>> {
    return this.get<IApi<IUser>>(`${this.apiUrl}/users/info`);
  }
}
